
import { wrapWithCaller } from './wrapWithCaller';

export const executeCallbacks = (callbacks, caller = undefined) => {

    if(Array.isArray(callbacks)) {
        callbacks.map(cb => {
            if(typeof cb === 'function') {
                cb();
            } else {
                console.log(wrapWithCaller('One of callbacks in array is not a function! Cannot execute!', caller));
            }
        });
    } else {
        if(typeof callbacks === 'function') {
            callbacks();
        } else {
            console.log(wrapWithCaller('Not a function is provided as callback! Cannot execute!', caller));
        }
    }
};